


















import AppForm from "../atoms/AppForm.vue";
import AppTextarea from "../atoms/AppTextarea.vue";
import Vue, { PropType } from "vue";
export type Recipe = {
  title: string;
  description: string;
};

type Data = {
  recipeItem: {
    recipeTitle: string;
    recipeDescription: string;
  };
};

export default Vue.extend({
  components: {
    AppForm,
    AppTextarea
  },
  props: {
    recipe: {
      type: Object as PropType<Recipe>
    }
  },
  data(): Data {
    return {
      recipeItem: {
        recipeTitle: this.recipe.title,
        recipeDescription: this.recipe.description
      }
    };
  },
  methods: {
    onChangeRecipeTitle(): void {
      this.$emit("on-change-recipe-title", this.recipeItem);
    }
  }
});
